



































  import { Vue, Component } from 'vue-property-decorator'
  import { mapGetters } from 'vuex'
  import sparqlService from '../service/SparqlService'
  import main from '../main'

  @Component({
    components: { },
    computed: mapGetters([
      'ontologies'
    ])
  })
  export default class RootPane extends Vue {
    downloadUrl:String = ''
    mounted () {
      this.$nextTick(function () {
        this.downloadUrl = sparqlService.serverUrl + '/data/'
        console.log('RootPane: mounted hook')
        main.store.commit('resetOntology')
        main.store.commit('leftPane', 'Ontologies')
        sparqlService.getOntologiesAsync()
      })
    }
  }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RootPane.vue